import { AvField, AvForm } from 'availity-reactstrap-validation'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button, FormGroup, Label } from 'reactstrap'
import PageTitle from '../../../../Layout/AppMain/pageTitle'
import { request } from '../../../../Redux/Sagas/requests/api'
import { clearCurrentRowData, clearParentTableData, fetchUpdateApiData } from '../../../../Redux/Reducers/CMS'
import { isSuccessResponse } from '../../../../helper'
import TicketFileUpload from '../EditTicket/ticketChat/ticketFileUpload'

const AddTicket = ({ setAddGridDataDetail }) => {
  const dispatch = useDispatch()
  const [submitting, setSubmitting] = useState(false)
  const [base64File, setBase64File] = useState()
  const [file, setFile] = useState()

  const onGoBack = () => {
    dispatch(fetchUpdateApiData())
    dispatch(clearCurrentRowData())
    dispatch(clearParentTableData())
    setAddGridDataDetail({ open: false })
  }

  const onSubmit = (_e, values) => {
    setSubmitting(true)
    request('raise-ticket/ticket/admin-create', 'POST', {
      subject: values.subject,
      message: values.message,
      booking_id: values.booking_id || null,
      attachment: base64File || null,
    })
      .then((res) => {
        if (isSuccessResponse(res, 'Ticket created successfully!')) {
          onGoBack()
        }
      })
      .finally(() => setSubmitting(false))
  }

  return (
    <div className='px-3'>
      <PageTitle heading='Add Ticket' subheading='Raise a new query ticket' icon='pe-7s-browser icon-gradient bg-happy-fisher' hideBreadCrumbs />
      <Button color='dark' className='mt-2 mb-3' onClick={onGoBack}>
        Back
      </Button>
      <AvForm onValidSubmit={onSubmit} className='mt-3' style={{ maxWidth: 640 }}>
        <AvField name='subject' label='Subject' type='text' required />
        <AvField name='message' label='Message' type='textarea' rows='5' required />
        <AvField
          name='booking_id'
          label='Booking ID (optional)'
          type='text'
          helpMessage='If provided, ticket is filed under Bookings; otherwise General Queries.'
        />
        <FormGroup>
          <Label>Attachment (optional)</Label>
          <TicketFileUpload setBase64File={setBase64File} setFile={setFile} file={file} />
          <small className='text-muted d-block mt-1'>Optional — PDF, CSV, images, Office docs, zip, etc. (max 10MB).</small>
        </FormGroup>
        <Button color='success' disabled={submitting} className='mt-2'>
          {submitting ? 'Creating…' : 'Create Ticket'}
        </Button>
      </AvForm>
    </div>
  )
}

export default AddTicket
